/**
 * Generated from syncly-creator-spec/open-api/campaign.openapi.yaml by scripts/openapi-converter.
 * Do not edit this file directly.
 */

import { socialApiClient } from '@/shared/api-client/social-api-client';
import z from 'zod';
import { countResponseSchema } from '../campaign-schema';

export const getCampaignCountPathSchema = z.object({ workspaceId: z.string() });

export const getCampaignCountOperationResponseSchema = countResponseSchema;

export type GetCampaignCountInput = {
  path: z.input<typeof getCampaignCountPathSchema>;
  signal?: AbortSignal;
};

export async function getCampaignCount({
  path,
  signal,
}: GetCampaignCountInput): Promise<
  z.infer<typeof getCampaignCountOperationResponseSchema>
> {
  const parsedPath = getCampaignCountPathSchema.parse(path);

  const response = await socialApiClient.get(
    `workspaces/${parsedPath.workspaceId}/campaigns/count`,
    {
      signal,
    },
  );
  return getCampaignCountOperationResponseSchema.parse(await response.json());
}
